import { constants as config } from '@config';

import ImagesFactory from '../../../factory/images';
import VideoGetter from '../getters/video';
import VideoSetter from '../setters/video';

import ElementCreator from './abstract/element';

module.exports = VideoCreator;

function VideoCreator () {}

VideoCreator.prototype = new ElementCreator();
VideoCreator.prototype.constructor = VideoCreator;

VideoCreator.prototype.initialize = function () {
  ElementCreator.prototype.initialize.call(this);

  this.mandatory = ['thumb_src'];

  _.extend(this.defaults, {
    file: null,
    source: null,
    thumb_src: null,
    smart_asset: null
  });
};

VideoCreator.prototype.create = function (data) {
  const youtubeSource = this._getYoutubeCode(data.source);
  if (!youtubeSource) return this.createVideoElement(data);

  data.source = youtubeSource || data.source;
  data.thumb_src = data.thumb_src || 'http://img.youtube.com/vi/' + data.source + '/mqdefault.jpg';

  const element = this._createVideoContainer(data);
  const isExternalThumbnail = !ImagesFactory.isAmazonImage(data.thumb_src);

  isExternalThumbnail && this._resizeExternalThumbnail(element, data);
  isExternalThumbnail || this._smartImageLoad(element, data);

  this.trigger('', element.id);

  return element.id;
};

VideoCreator.prototype.createVideoElement = function (data) {
  const element = this.canvas.addElement('video', data);

  this._appendCropBox(element, data);
  this.trigger('', element.getAttribute('id'));

  // Not false
  if (typeof data.selected === 'undefined' || data.selected) {
    this.canvas.selectOnly([element]);
  }

  return element.getAttribute('id');
};

VideoCreator.prototype._createVideoContainer = function (data) {
  const href = data.source
    ? 'https://www.youtube.com/watch?v=' + data.source
    : data.file;

  const attr = {
    id: this.canvas.getNextId(),
    class: 'element video layoutBox quick-delete',
    'xlink:href': href,
    'data-video-type': 'youtube'
  };

  if (data.from_library) Object.assign(attr, { 'from-library': 'true' });

  const video = this.canvas.addSvgElementFromJson({ element: 'a', attr });
  this._appendVideoThumbnail(video, data);
  this._appendYoutubePlayIcon(video);
  this._appendCropBox(video, data);

  this.canvas.clearSelection();
  this.canvas.selectOnly([video]);

  return video;
};

VideoCreator.prototype._resizeExternalThumbnail = VideoSetter.prototype._resizeExternalThumbnail;
VideoCreator.prototype._matchBoxToImage = VideoSetter.prototype._matchBoxToImage;
VideoCreator.prototype._matchImageToBox = VideoSetter.prototype._matchImageToBox;
VideoCreator.prototype.updateSize = VideoSetter.prototype.updateSize;
VideoCreator.prototype._smartImageLoad = VideoSetter.prototype._smartImageLoad;
VideoCreator.prototype._appendYoutubePlayIcon = VideoSetter.prototype._appendYoutubePlayIcon;

VideoCreator.prototype._appendVideoThumbnail = function (element, data) {
  data = this.getAddData(data);

  const attr = {
    x: data.x,
    y: data.y,
    id: this.canvas.getNextId(),
    width: data.width,
    height: data.height,
    'xlink:href': data.url
  };

  const image = this.canvas.addSvgElementFromJson({ attr, element: 'image' });

  element.appendChild(image);
};

VideoCreator.prototype.getAddData = function (data) {
  const getDefinedData = _.bind(this.getDefinedData, this, data);

  return {
    x: getDefinedData('position.x'),
    y: getDefinedData('position.y'),
    url: getDefinedData('thumb_src'),
    width: getDefinedData('size.width'),
    height: getDefinedData('size.height')
  };
};

VideoCreator.prototype._appendCropBox = function (element, data) {
  INKIVE.EditorFacade.handle(element.id, 'crop', {
    quiet: true,
    scale: 1,
    skip_selection: true,
    clip_path: this.getAddData(data)
  });
};

VideoCreator.prototype._getYoutubeCode = VideoGetter.prototype._getYoutubeCode;
